import ConfirmationModal from "./container";

export default ConfirmationModal;